import { all, select } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';
import * as InsuranceSelectors from '../../selectors';

export const insuranceStageMoveToInsurerInfoState = new CreateStage({
  action: InsuranceConstants.ACTIONS.MOVE_TO_INSURER_INFO_STATE,
  handler: function* () {
    const [applicationId, values, selectedBank, isInCredit] = yield all([
      selectWhen(InsuranceCalculationSelectors.selectApplicationId),
      select(InsuranceSelectors.selectDataValues),
      select(InsuranceCalculationSelectors.selectSelectedBank),
      select(InsuranceCalculationSelectors.selectIsInCredit),
    ]);
    const {
      [InsuranceConstants.DATA_FIELDS.MARK_AS_PTS]: markAsPTS,
      [InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS]: modelAsPTS,
      [InsuranceConstants.DATA_FIELDS.TYPE_OF_USE]: typeOfUse,
    } = values;
    const { id: bankId } = selectedBank ?? {};

    // TODO: Ждем задачу https://nda.ya.ru/t/PdOndAvu7FTsas
    // eslint-disable-next-line no-unused-vars
    const request = {
      applicationId,
      params: { bankId, isInCredit, markAsPTS, modelAsPTS, typeOfUse },
    };
  },
  name: InsuranceConstants.STAGES_FIELDS.MOVE_TO_INSURER_INFO_STATE,
}).watcher;
